import { PlanDetails } from "./plan-details";

export class ValidMatchingEntry {

  effectivePackageManagementId: string;
  customerSetId: string;
  formularyPackageId: string;
  formularyPackageDate: string;
  effectiveFormularyPackageId: string;
  formularyPackageEffectiveDate: string;
  formularyPackageTerminationDate: string;
  drugAttribuuteTypeId: string;
  drugListEntryLevelValueText: string;
  medicationId: string;
  medicationShortDescription: string;
  ndcId: string;
  ndcDescription: string;
  gcnId: string;
  brandName: string;
  medicationDescription: string;
  labelName: string;
  gpiCode: string;

   druglabelNameText: string;
	 brandGenericCode: string;

  tierValueCount: string;
  paProgramCode: string;
  qlProgramCode: string;
  stProgramCode: string;
  genericShortName: string;
  genericName: string;
  drugClass: string;
  genericProductId: string;
  multiSourceCode: string;
  brandGenericIndicator: string;
  gcnSequenceNumber: string;
  routeDescription: string;
  fdaMarketingCategory: string;

  acaProgramCode: string;
  ageProgramCode: string;
  code1ProgramCode: string;
  excludedDrugProgramCode: string;
  firstFillFreeProgramCode: string;
  gapCoverageProgramCode: string;
  genderProgramCode: string;
  highCostDrugProgramCode: string;
  homeInfusionProgramCode: string;
  injectableSpecialityDrugProgramCode: string;
  limitedAccessProgramCode: string;
  longActingProgramCode: string;
  mailOrderProgramCode: string;
  maintanaceProgramCode: string;
  nonPreferredDrugProgramCode: string;
  nonExtendDaySupProgramCode: string;
  oralAntiCancerProgramCode: string;
  otherProgramCode: string;
  otcDrugProgramCode: string;
  partBProgramCode: string;
  partailGapProgramCode: string;
  preferredDrugProgramCode: string;
  rebateProgramCode: string;
  shortActingProgramCode: string;
  specialityProgramCode: string;
  valueBasedINSDesignProgramCode: string;
  femaleAtBirthCode: string;
  maleAtBirthCode: string;
  protectedDrugClassCode: string;
  availableViaBHRSCode: string;

  planDetails : PlanDetails;

}
